import React from "react";
import { Box, Typography, Switch, FormControlLabel, Tooltip } from "@mui/material";
import { useTranslation } from "react-i18next";

const NotificationHeader = ({
    showReadNotifications,
    setShowReadNotifications,
    unreadCount,
    readCount,
    hasAnyNotifications,
    onClearAll,
    isDarkTheme,
    canClearAll = true
}) => {
    const { t } = useTranslation();

    return (
        <Box
            sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "12px 16px",
            }}
        >
            <Typography sx={{ fontWeight: 500, fontSize: "16px" }}>
                {t("notifications.NOTIFICATIONS")}
            </Typography>

            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <FormControlLabel
                    labelPlacement="start"
                    control={
                        <Switch
                            size="small"
                            checked={showReadNotifications}
                            onChange={(e) => setShowReadNotifications(e.target.checked)}
                        />
                    }
                    label={
                        <Typography sx={{ fontWeight: 500, fontSize: "12px" }}>
                            {showReadNotifications
                                ? `${t("notifications.READ")} (${readCount})`
                                : `${t("notifications.UNREAD")} (${unreadCount})`}
                        </Typography>
                    }
                    sx={{
                        m: 0,
                        background: isDarkTheme ? "#2D2C5A" : "#F2F3FE",
                        borderRadius: "20px",
                        padding: "2px 6px 2px 8px",
                        border: "0.5px solid #c4c4c95c",
                    }}
                />

                <Tooltip
                    title={
                        canClearAll ? t("common.CLEAR_ALL") :
                            t("notifications.CANNOT_CLEAR_WITH_IN_PROGRESS")

                    }
                >
                    <Typography
                        onClick={(hasAnyNotifications && canClearAll) ? onClearAll : undefined}
                        sx={{
                            fontSize: "0.75rem",
                            cursor: (hasAnyNotifications && canClearAll) ? "pointer" : "not-allowed",
                            opacity: (hasAnyNotifications && canClearAll) ? 1 : 0.5,
                        }}
                    >
                        {t("common.CLEAR_ALL")}
                    </Typography>
                </Tooltip>
            </Box>
        </Box >
    );
};

export default NotificationHeader;